import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=211c9d00&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"
import style0 from "./Step6.vue?vue&type=style&index=0&id=211c9d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c9d00",
  null
  
)

export default component.exports